import React, { useState, useEffect } from "react";
import { XIcon } from "@heroicons/react/outline";
import Select, { SingleValue } from "react-select";
import roles from "../../../../utils/roles.json";
import { IReactSelect } from "../../../../model/interface/keyValuePair";
import Loader from "../../../shared/loader/loader";
import { toast } from "react-toastify";
import { updateUser, updateUserRole } from "../../../../api/miniCrm.service";
import Profile from "../../../../model/profile";
import { connect } from "react-redux";

interface IUserEditPopup {
  onClose: () => void;
  user: any;
  profile?: Profile;
}
function UserEditPopup(props: IUserEditPopup) {
  const [user, setUser] = useState(props.user);
  const defaultSelect = { label: "", value: 0 };
  const [userRole, setUserRole] = useState<IReactSelect>(defaultSelect);
  const [checkRole, setCheckRole] = useState<IReactSelect>(defaultSelect);
  const [loading, setLoading] = useState<boolean>(false);
  const DistrictRoldId = 4;

  useEffect(() => {
    const role = roles.filter((ds) => ds.value === user.roleId);
    if (role && Object.keys(role).length) {
      setUserRole(role[0]);
      setCheckRole(role[0]);
    }
  }, []);

  async function update() {
    setLoading(true);
    if (userRole.value !== checkRole.value) {
      await updateUserRole(user.userId, userRole.value);
    }

    try {
      const resp = await updateUser({
        username: user.username,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        userId: user.userId,
        updatedByUser: props?.profile?.userId,
      });

      if (resp.status === 200) {
        toast.success("User updated successfully");
        props.onClose();
        setLoading(false);
      } else {
        toast.error("User update failed");
        setLoading(false);
      }
    } catch (e) {
      toast.error("User update failed");
      setLoading(false);
    }
  }

  const handleChangeUserRole = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      setUserRole(option);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div
        className="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div className="rounded-lg inline-block align-bottom bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 h-auto">
            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                onClick={() => props.onClose()}
                type="button"
                className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary"
              >
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            <div className="flex border-b">
              <h2 className="text-gray-700 font-semibold text-xl">Edit</h2>
            </div>

            <div className="mt-3 grid grid-cols-2 gap-4">
              <div>
                <span className="whitespace-nowrap">Username</span>
                <input
                  value={user.username}
                  onChange={(e) =>
                    setUser({ ...user, username: e.target.value })
                  }
                  type="text"
                  autoComplete="off"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                />
              </div>

              <div>
                <span className="whitespace-nowrap"></span>
                <div className="flex"></div>
              </div>

              <div>
                <span className="whitespace-nowrap">First Name</span>
                <input
                  value={user.firstName}
                  onChange={(e) =>
                    setUser({ ...user, firstName: e.target.value })
                  }
                  type="text"
                  autoComplete="off"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                />
              </div>

              <div>
                <span className="whitespace-nowrap">Last Name</span>
                <input
                  value={user.lastName}
                  onChange={(e) =>
                    setUser({ ...user, lastName: e.target.value })
                  }
                  type="text"
                  autoComplete="off"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                />
              </div>

              <div>
                <span className="whitespace-nowrap">Email</span>
                <input
                  value={user.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                  type="text"
                  autoComplete="off"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                />
              </div>
              <div>
                <span className="whitespace-nowrap">Role</span>
                <Select
                  className="mt-1 text-sm"
                  value={userRole}
                  options={roles.filter(
                    (role) => role.value !== DistrictRoldId
                  )}
                  onChange={handleChangeUserRole}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                  menuPortalTarget={document.body} // Render the dropdown outside the modal
                  menuPosition="fixed" // Ensure fixed positioning
                />
              </div>
            </div>

            <div className="flex justify-end pt-4">
              <button
                type="button"
                onClick={() => update()}
                className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              >
                Update
              </button>

              <button
                type="button"
                onClick={() => props.onClose()}
                className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
              >
                <span>Cancel</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(UserEditPopup);
